/* eslint-disable jsx-a11y/media-has-caption */
const ViewVideo = ({ resource }) => (
  <video controls className='video-view'>
    <source src={resource} type='video/mp4' />
  </video>
);

export default ViewVideo;
